angular.module('logbook')
  .factory('reminderStatusFactory', [function() {
    var service = {};
    
    service.getStatusTooltipText = function(reminder)
    {
       var retval = reminder.status.description;
       if( reminder.late && reminder.status.name == 'P')
          retval += ', should have started already';
       else if( reminder.late && reminder.status.name == 'A')
          retval += ', should have ended already'
       else if( reminder.soon && reminder.status.name == 'P')
          retval += ', should start soon';
       else if( reminder.soon && reminder.status.name == 'P')
          retval += ', should end soon';
       
       return retval;
    }
    
    service.getReminderIconClass = function(reminder)
    {
       var retval = 'glyphicon reminder-status label ';
       if( reminder.late )
          retval += 'glyphicon-bell label-danger reminder-late';
       else if( reminder.soon )
          retval += 'glyphicon-bell label-warning reminder-soon';
       else if( reminder.status.name == 'P' )
          retval += 'glyphicon-bell label-success';
       else if( reminder.status.name == 'A' )
          retval += 'glyphicon-time label-primary';
       else if( reminder.status.name == 'E' || reminder.status.name == 'K')
          retval += 'glyphicon-ok label-info';
       else if( reminder.status.name == 'C' )
          retval += 'glyphicon-remove label-default';
       else if( reminder.status.name == 'D' )
          retval += 'glyphicon-remove label-default'
       return retval;
       
    }

    return service;
  }]);
